import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { AfterViewChecked, ChangeDetectorRef, Component, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { BsModalService } from 'ngx-bootstrap';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { TabDirective } from 'ngx-bootstrap/tabs';
import { ToastrService } from 'ngx-toastr';
import { concat, Observable, of } from 'rxjs';
import { catchError, first } from 'rxjs/operators';
import { ComboEstado, ComboSituacion } from '../../../core/model/combos';
import {
  ActualizaConcepto, ActualizaEstadosContenido, ActualizaEstadosSolicitud, ContabilidadContenido, ContabilidadOption,
  ContabilidadOptionValue, ContabilidadValor, ContabilidadValorCombo, DetalleSolicitud, FechaContenidos,
  FechaSLA, SituacionContenido, SituacionSolicitud, TableContentInfo
} from '../../../core/model/detalle-solicitud';
import { FileType } from '../../../core/model/file';
import { FlujoAprobaciones } from '../../../core/model/flujo-aprobaciones';
import { FileData, MassiveLoadExcelField, MassiveLoadResult } from '../../../core/model/massive-load-result';
import { SolicitudMaterial } from '../../../core/model/solicitud-materiales';
import { SolicitudesAprobadas } from '../../../core/model/solicitudes';
import { Template } from '../../../core/model/template';
import { ValorCampoSerie } from '../../../core/model/valor-campo-serie';
import { AlbaranService } from '../../../core/services/albaran.service';
import { AuthenticationService } from '../../../core/services/authentication.service';
import { DetalleService } from '../../../core/services/Detalle/detalle.service';
import { EstadosService } from '../../../core/services/estados.service';
import { FileManagerService } from '../../../core/services/files/file-manager.service';
import { FlujoAprobacionesService } from '../../../core/services/flujo-aprobaciones.service';
import { GruposService } from '../../../core/services/grupos.service';
import { PopulateService } from '../../../core/services/populate.service';
import { ProveedoresService } from '../../../core/services/proveedores.service';
import { SeriesService } from '../../../core/services/series.service';
import { SolicitudServicioService } from '../../../core/services/solicitud-servicio.service';
import { SolicitudesService } from '../../../core/services/solicitudes.service';
import { TemplatesService } from '../../../core/services/templates.service';
import { UtilitiesService } from '../../../core/services/Utility/utilities.service';
import { ModalConfirmationComponent } from '../../../utils/modal-confirmation/modal-confirmation.component';
import { CargaMasivaComponent } from '../../carga-masiva/carga-masiva.component';
import { ChangeProveedorSolicitudComponent } from '../change-proveedor-solicitud/change-proveedor-solicitud.component';
import { ChangeoptionsSolicitudComponent } from '../changeoptions-solicitud/changeoptions-solicitud.component';


@Component({
  selector: 'app-detalledocout',
  templateUrl: './detalledocout.component.html',
  styleUrls: ['./detalledocout.component.css'],
  providers: [SolicitudesService]
})

export class DetalledocoutComponent implements OnInit, OnDestroy, AfterViewChecked {
  id: number;
  isGestionable: any;

  Boxtype = 'box-primary';
  Title: string;
  Description: string;
  Padre: string;
  Hijo: string;

  hasMoreThanOneTable: boolean;

  isDocoutUser: boolean;
  isGestorUser = false;
  statusCode: number;
  requestProcessing = false;
  requestContent = false;
  requestConta = false;
  noData = false;
  noDataContent = false;
  noDataConta = false;
  mensajeToShow: string;
  mensajeToShow2: string;
  mensajeToShowConta: string;
  loadingMassive = false;

  limitDate: Date;
  entryDateMassive: Date;
  realEndDateMassive: Date;
  entryDateContent: Date;
  expirationDateContent: Date;
  realEndDateContent: Date;
  fechaFinalizacionMassiveRows: Date;
  fechaEntradaMassiveRows: Date;

  rowsContenidosNoInventariados: TableContentInfo[];
  rowsContenidosExpedientes: TableContentInfo[];
  rowsContenidosContenedores: TableContentInfo[];
  rowsContenidosAZs: TableContentInfo[];
  rowsMateriales: SolicitudMaterial[];

  @ViewChild('avisofin') private template_aviso: TemplateRef<any>;
  @ViewChild('avisoCancel') private templateCancel: TemplateRef<any>;

  consultasLocalizadas = 0;
  consultasNoLocalizadas = 0;
  consultas = 0;

  viewDetails: DetalleSolicitud;
  viewConta: ContabilidadContenido[];
  updateConcepto: ActualizaConcepto[];
  estadosContenido: ActualizaEstadosContenido[];
  estadosSolicitud = new ActualizaEstadosSolicitud();

  contabilidad: ContabilidadOption[] = [];

  single_selected: TableContentInfo;
  idcontenido: string;

  //proveedorContenido
  proveedorCont: string;
  idProveedorCont: number;
  correoProveedorCont: string;
  telefonoProveedorCont: string;
  contactoProveedorCont: string;
  contenidoSeleccionadoMostrado = false;

  idestado: number;
  idsituacion: number;
  idEstContentMasiva = -1;
  idSituacionMasiva = -1;
  isInventariado = false;

  idestado_original: number;
  idsituacion_original: number;

  isNueva = false;
  isFinalizada = false;
  isCancelled = false;
  modalRef: BsModalRef;
  reload = false;
  reloadObservations = false;
  loadingAuthorizationTable = false;
  loadingCancelarSolicitud = false;
  // Contenidos
  idEstContent: number;
  idSitContent: number;

  idEstContent_original: number;
  idSitContent_original: number;

  isContentFinalizado = false;
  isContentCancelled = false;

  tieneOriginalCopia = false;
  esActualUrgente = false;
  esActualOriginal = false;

  private subscription;
  private subscription_change;
  private subscription_detail;
  private subscription_state;
  private subscription_get;
  private subscription_update;

  public bsConfig: BsDatepickerConfig;
  cbEstado: ComboEstado[];
  cbEstadoContenido: ComboEstado[];
  cbSituacion: SituacionSolicitud[];
  cbSituacionContenido: ComboSituacion[];
  cbSituacionMasiva: ComboSituacion[];


  allSituaciones: SituacionSolicitud[];
  allSituacionesContenido: SituacionContenido[];

  errorcomboestado = false;
  errorcombosituacion = false;
  errorcomboestadocontenido = false;
  summaryerror = false;

  showSituationMassiveYesButton = false;
  lineacontenido: any;
  approvingUsers: FlujoAprobaciones[];
  approvingGroup: FlujoAprobaciones[];

  isMaterialRequested: boolean;
  thinking = false;

  // ngx-datatable options
  customMessages = {
    emptyMessage: 'No hay solicitudes disponibles',
    totalMessage: 'Total',
    selectedMessage: 'Selección'
  };
  customClasses = {
    sortAscending: 'fas fa-sort-up',
    sortDescending: 'fas fa-sort-down',
    pagerLeftArrow: 'fas fa-chevron-left',
    pagerRightArrow: 'fas fa-chevron-right',
    pagerPrevious: 'fas fa-step-backward',
    pagerNext: 'fas fa-step-forward'
  };

  contenidoFiles = [];
  requestFilesMassiveLoad = [];
  requestFilesDocumentation = [];

  templateId: number;
  loading = false;

  isLoadingContents = true;

  contenidoSeleccionado: number;
  downloadingAlbaran = false;
  albaranBlobUrl = undefined;
  isIE = window.navigator && window.navigator.msSaveOrOpenBlob;

  comboContabilidadSelected: number;

  //🥑🥑
  isProveedorDocout = false;
  tieneProveedores = false;
  tienePermisoCambiarProveedores = false;

  //🥑🥑
  isProveedorDocoutCont = false;
  tieneProveedoresCont = false;
  tienePermisoCambiarProveedoresCont = false;

  // OAA:
  infoAdicionalGrupo: string;
  isProveedorUser = false;
  isLoadingSituaciones = true;

  constructor(private activatedRoute: ActivatedRoute,
    private translateService: TranslateService,
    public authService: AuthenticationService,
    private utilservice: UtilitiesService,
    private detalleservice: DetalleService,
    private populateService: PopulateService,
    private toastr: ToastrService,
    private modalservice: BsModalService,
    private router: Router,
    private datePipe: DatePipe,
    private solicitudeservice: SolicitudesService,
    private flujoAprobacionesService: FlujoAprobacionesService,
    private fileManagerService: FileManagerService,
    private seriesService: SeriesService,
    private solicitudServicioService: SolicitudServicioService,
    private templatesService: TemplatesService,
    private cdRef: ChangeDetectorRef,
    private albaranService: AlbaranService,
    private utilitiesService: UtilitiesService,
    private proveedoresService: ProveedoresService,
    private estadosService: EstadosService,
    private grupoService: GruposService
  ) { }

  ngOnInit() {
    this.load();
  }

  load() {
    this.SetEnviroment();
    // this.InitLanguage();
    this.activatedRoute.paramMap.subscribe((params: ParamMap) => {
      this.id = +params.get('id');
      this.solicitudServicioService.isGestionable(this.id)
        .subscribe((p) => this.isGestionable = p);
      const contenidoSeleccionado = params.get('contenidoSeleccionado');
      this.contenidoSeleccionado = contenidoSeleccionado ? parseInt(contenidoSeleccionado, 10) : undefined;

      if (this.id) {
        this.getDetailsSolicitud();
        this.solicitudServicioService.isGestionable(this.id)
          .subscribe((p) => this.isGestionable = p);
      } else {
        this.router.navigate(['docout', { outlets: { contenido: ['panelmando'] } }]);
      }

    });
  }

  cancelarSolicitud(rollback: boolean) {
    this.loadingCancelarSolicitud = true;
    this.solicitudeservice.cancelarSolicitudInicial(this.id, rollback).subscribe(
      (p) => {
        this.loadingCancelarSolicitud = false;
        if (!p.isok) {
          this.toastr.warning(
            'Ha ocurrido un error al intentar cancelar la solicitud. Mas info: ' + p.msg);
        } else {
          this.toastr.success('Se ha cancelado correctamente la solicitud');
          this.load();
        }
      },
      () => {
        this.loadingCancelarSolicitud = false;
      }
    );
  }

  ngAfterViewChecked() {
    this.cdRef.detectChanges();
  }

  setGestorUser() {

    if (this.viewDetails.ID_SERIE != null || this.viewDetails.ID_SERIE != undefined) {
      this.authService.isGestionador(this.viewDetails.ID_SERIE).subscribe(result => { this.isGestorUser = result; });
    } else {
      this.isGestorUser == false;
    }
  }

  SetEnviroment() {
    this.bsConfig = this.utilservice.getDatepickerConfig();
    this.authService.isDocOutUser()
      .then((isDocUser: boolean) => {
        this.isDocoutUser = isDocUser;
      });

    this.authService.isProveedorUser().then((isProvUser: boolean) => {
      this.isProveedorUser = isProvUser;
    });

    /*this.solicitudServicioService.isGestionable(this.id)
      .subscribe((p) => this.isGestionable = p);*/
  }

  InitLanguage() {
    this.subscription = this.translateService.get(['detalle'])
      .subscribe(values => { this.TranslateText(values); });

    this.subscription_change = this.translateService.onLangChange.subscribe(() => {
      this.translateService.get(['detalle'])
        .subscribe(values => { this.TranslateText(values); });
    });
  }

  TranslateText(values: any) {

  }

  ngOnDestroy() {
    if (!this.subscription == null) { this.subscription.unsubscribe(); }
    if (!this.subscription_change == null) { this.subscription_change.unsubscribe(); }
    if (!this.subscription_detail == null) { this.subscription_detail.unsubscribe(); }
    if (!this.subscription_state == null) { this.subscription_state.unsubscribe(); }
    if (!this.subscription_get == null) { this.subscription_get.unsubscribe(); }
    if (!this.subscription_update == null) { this.subscription_update.unsubscribe(); }

    this.populateService = null;
    this.detalleservice = null;
    this.utilservice = null;
    this.router = null;
    this.toastr = null;
    this.translateService = null;
    this.authService = null;
    this.modalservice = null;
    this.errorcomboestado = false;
    this.errorcombosituacion = false;
    this.summaryerror = true;
    this.modalRef = null;

  }

  // endregion


  // region "Estados/Situacion getters"

  getSituacion(idtiposervicio: number) {
    this.isLoadingSituaciones = true;
    this.subscription_state = this.detalleservice.getSituacionesByService(idtiposervicio)
      .subscribe(
        situaciones => {
          this.allSituaciones = situaciones;
          if (this.isDocoutUser || this.isGestionable) {
            this.idsituacion = this.viewDetails.ID_SITUACION_DOCOUT;
            this.idsituacion_original = this.viewDetails.ID_SITUACION_DOCOUT;
          } else {
            this.idsituacion = this.viewDetails.ID_SITUACION_CLIENTE;
            this.idsituacion_original = this.viewDetails.ID_SITUACION_CLIENTE;
          }
          this.cbSituacion = situaciones.filter(sit => sit.ESTADO.Id == this.idestado);

          if (this.cbSituacion.length <= 0) {
            this.summaryerror = true;
            this.errorcombosituacion = true;
          }
          this.isLoadingSituaciones = false;
        },
        errorCode => {
          this.isLoadingSituaciones = false;
          this.cbSituacion = [];
          this.errorCode();
        });
  }


  getEstado(idcliente: number, idtiposervicio: number) {
    this.subscription_state = this.populateService.getComboEstado(idcliente, idtiposervicio, this.id)
      .subscribe(
        estados => {
          this.cbEstado = estados;
          if (this.isDocoutUser || this.isGestionable) {
            this.idestado = this.viewDetails.ID_ESTADO_DOCOUT;
            this.idestado_original = this.viewDetails.ID_ESTADO_DOCOUT;
          } else {
            this.idestado = this.viewDetails.ID_ESTADO_CLIENTE;
            this.idestado_original = this.viewDetails.ID_ESTADO_CLIENTE;
          }
          const stateSelected = this.cbEstado.find(x => x.ID == this.idestado);
          if (stateSelected) {
            this.isFinalizada = stateSelected.IsFinalize;
            this.isCancelled = stateSelected.IsCanceled;
            this.isNueva = stateSelected.TIPO === 'INICIAL';
          }

          if (this.cbEstado.length <= 0) {
            this.summaryerror = true;
            this.errorcomboestado = true;
            this.cbEstado.push({
              ID: this.viewDetails.ID_ESTADO_DOCOUT,
              NOMBRE: this.viewDetails.NOMBRE_ESTADO_DOCOUT,
              TIPO: '',
              IsFinalize: false,
              IsCanceled: false,
              IsIncidencia: false
            });
          }
          this.getSituacion(this.viewDetails.ID_TIPO_SERVICIO);

        },
        errorCode => {
          this.cbEstado = [];
          this.errorCode();
        });
  }


  getSituacionContenido(idtiposervicio: number) {
    this.subscription_state = this.detalleservice.getSituacionesContenidoByService(idtiposervicio)
      .subscribe(
        situaciones => {
          this.allSituacionesContenido = situaciones;
          // cargamos las situaciones dependientes del estado
          // onchange estado recargar situaciones
          const situacionesSelected = situaciones.filter(sit => sit.ESTADO.Id == this.idEstContent).map(sit => sit.SITUACION);
          this.cbSituacionContenido = [...situacionesSelected];
          this.cbSituacionMasiva = [...situacionesSelected];

          if (this.cbSituacionContenido.length <= 0) {
            this.summaryerror = true;
            this.errorcombosituacion = true;
          }


        },
        errorCode => {
          this.cbSituacionContenido = [];
          this.cbSituacionMasiva = [];
          this.errorCode();
        });
  }

  getEstadoContenido(idcliente: number, idtiposervicio: number, idEstadoContent: number, idSituacionContent: number) {
    if (!this.cbEstadoContenido) {
      this.subscription_state = this.populateService.getComboEstadoContenido(idcliente, idtiposervicio)
        .subscribe(
          estados => {
            this.cbEstadoContenido = estados;
            this.manageEstadoContenido(idEstadoContent, idSituacionContent);
          },
          errorCode => {
            this.cbEstadoContenido = [];
            this.errorCode();
          });
      return;
    }
    this.manageEstadoContenido(idEstadoContent, idSituacionContent);
  }

  private manageEstadoContenido(idEstadoContent: number, idSituacionContent: number) {


    const contentState = this.cbEstadoContenido.find(x => x.ID == idEstadoContent);
    this.idEstContent = idEstadoContent;
    this.idSitContent = idSituacionContent;
    this.idEstContent_original = idEstadoContent;
    this.idSitContent_original = idSituacionContent;

    this.isContentFinalizado = contentState ? contentState.IsFinalize : false;
    this.isContentCancelled = contentState ? contentState.IsCanceled : false;

    if (this.cbEstadoContenido.length <= 0) {
      this.summaryerror = true;
      this.errorcomboestadocontenido = true;
      this.cbEstadoContenido.push({
        ID: this.viewDetails.ID_ESTADO_DOCOUT,
        NOMBRE: this.viewDetails.NOMBRE_ESTADO_DOCOUT,
        TIPO: '',
        IsFinalize: false,
        IsCanceled: false,
        IsIncidencia: false
      });
    }

    this.getSituacionContenido(this.viewDetails.ID_TIPO_SERVICIO);
  }

  /**
   * Obtención de guid, fecha y nombre de todos los ficheros del contenido contentId
   * @param contentId Id del contenido cuyos GUID se desea recuperar
   */
  getContentImages(contentId: number): any[] {
    if (!contentId) {
      return [];
    }
    const content = this.getContentByIdContents(contentId);

    return !content || !content.ficheros ? null : content.ficheros
      .map(fichero => {
        return {
          guid: fichero.GUID, name: fichero.NOMBRE_FICHERO,
          date: new Date(fichero.FECHA)
        };
      });
  }

  public isMaterialsRequest() {
    return this.viewDetails.ID_SERIE == null;
  }

  getDetailsSolicitud() {
    this.preProcessDetails('Recuperando detalle de la solicitud');
    this.requestProcessing = true;
    this.isLoadingContents = true;
    this.subscription_detail = this.detalleservice.getViewDetails(this.id).pipe(first())
      .subscribe(contenido => {
        this.viewDetails = contenido;
        this.setGestorUser();
        this.limitDate = contenido.FECHA_SLA;
        if (this.idcontenido) {
          this.contenidoFiles = this.getContentImages(+this.idcontenido);
        }
        this.requestFilesMassiveLoad = contenido.FicherosCargaMasiva.map(fichero => {
          return { guid: fichero.GUID, name: fichero.NOMBRE_FICHERO, date: fichero.FECHA };
        });

        this.requestFilesDocumentation = contenido.FicherosDocumentacion.map(fichero => {
          return { guid: fichero.GUID, name: fichero.NOMBRE_FICHERO, date: fichero.FECHA };
        });
        if (!this.viewDetails) {
          this.noData = true;
        } else {
          this.isMaterialRequested = this.viewDetails.ID_SERIE == null;
          this.getEstado(this.viewDetails.ID_CLIENTE, this.viewDetails.ID_TIPO_SERVICIO);
          if (!this.isMaterialsRequest()) {
            this.solicitudServicioService.getRouteForExistingServiceRequest(contenido.ID_TIPO_SERVICIO)
              .pipe(first()).subscribe(route => {
                this.templatesService.getTemplateFields(route, this.viewDetails.ID_SERIE).pipe(first())
                  .subscribe((plantilla: Template) => {
                    this.templateId = plantilla.idPlantilla;
                  });
              });
          }
        }
        this.requestProcessing = false;

        // 🥑🥑 proveedor solicitud
        if (this.viewDetails.ID_PROVEEDOR == null) {
          this.isProveedorDocout = true;
        } else {
          this.isProveedorDocout = false;
        }

        // 🥑🥑 proveedor solicitud
        this.clienteTieneProveedores(this.viewDetails.ID_CLIENTE);
        this.usuarioTienePermisoCambioProveedor(this.authService.getUserId(), this.viewDetails.ID_PROVEEDOR);

        // OAA: Informacion adicional del grupo
        this.obtenerInfoAdicionalGrupo();
      },
        error => {
          this.errorCode();
          this.requestProcessing = false;
        });
  }

  getContabilidadDetails(idEstContent: number, idSitContent: number) {
    this.preProcessContabilidad('Recuperando contabilidad');
    this.subscription_detail = this.detalleservice.getContabilidadContenido(parseInt(this.idcontenido, null),
      this.viewDetails.ID_TIPO_SERVICIO, this.viewDetails.ID_CLIENTE)
      .subscribe(contabilidad => {
        this.viewConta = contabilidad;
        this.getEstadoContenido(this.viewDetails.ID_CLIENTE, this.viewDetails.ID_TIPO_SERVICIO, idEstContent, idSitContent); //  3, 3);
        if (!this.viewConta || this.viewConta.length === 0) {
          this.noDataConta = true;
          this.contabilidad = [];
        } else {
          this.noDataConta = false;
          this.viewConta.forEach(element => {
            if (element.KEY === 'COMBO') {
              element.VALORES.forEach(combo => {
                if (combo.TIPO === 'COMBO') {// no está de más volver a controlarlo
                  combo.comboboxConceptoSelected = combo.VALORES_COMBO[0].Id.toString();
                  combo.VALORES_COMBO.forEach(item => {
                    if (item.CANTIDAD > 0) {
                      const contabilidadOption = this.getContabilidadOption(combo.Id, item);
                      this.contabilidad.push(contabilidadOption);
                    }
                  });
                }
              });
            }
          });
        }
        this.requestConta = false;
      },
        errorCode => { this.errorCode(); });
  }
  private getContabilidadOption(Id: number, item: ContabilidadValorCombo): ContabilidadOption {
    const contabilidad = new ContabilidadOption();
    contabilidad.ID = Id;
    contabilidad.PARAM = new ContabilidadOptionValue();
    contabilidad.PARAM.Id = item.Id;
    contabilidad.PARAM.cantidad = item.CANTIDAD;
    contabilidad.PARAM.label = item.VALOR;

    return contabilidad;
  }

  // endregion

  // region "Update/saves/Deletes"

  updateEstadosSolicitud() {
    this.estadosSolicitud.ID_SOLICITUD_SERVICIO = parseFloat(this.id.toString());
    this.estadosSolicitud.ID_ESTADO = parseFloat(this.idestado.toString());
    this.estadosSolicitud.ID_SITUACION = parseFloat(this.idsituacion.toString());
    this.thinking = true;


    // Modifico para que si se quiere mover la solicitud a un estado que tenga cambio automatico, no lo cambie a este, sino al que se ha configurado
    // Primero compruebo si tiene que cambiar de forma automatica:
    const idProveedor = this.viewDetails.ID_PROVEEDOR;

    this.subscription_update = this.estadosService.getTieneCambioAutomaticoDocout(
      this.id, this.viewDetails.ID_DEPARTAMENTO, this.viewDetails.ID_SERIE, this.idestado, this.idsituacion, idProveedor).subscribe(tieneCambioAuto => {
        if (tieneCambioAuto) {
          // Recupero los datos del cambio automatico
          this.estadosService.getObtenEstadoCambioAutomaticoDocout(this.id, this.viewDetails.ID_DEPARTAMENTO, this.viewDetails.ID_SERIE,
            this.idestado, this.idsituacion, idProveedor).subscribe(estadoCambio => {

              // Primero cambio el estado, porque si lo hago al reves dejo de tener permisos para moverlo
              if (estadoCambio.IdEstadoDestino != null) {
                // Cambiar el estado final al que moveremos la solicitud
                this.estadosSolicitud.ID_SOLICITUD_SERVICIO = parseFloat(this.id.toString());
                this.estadosSolicitud.ID_ESTADO = parseFloat(estadoCambio.IdEstadoDestino.toString());
                this.estadosSolicitud.ID_SITUACION = parseFloat(estadoCambio.IdSituacionDestino.toString());

                this.detalleservice.updateEstadosSolicitud(this.estadosSolicitud)
                  .subscribe(success => {
                    this.proveedoresService.ActualizarIdProveedorSolicitud(this.id, estadoCambio.IdProveedorDestino,
                      'Cambio de proveedor automatico', 'Cambio de proveedor automatico').subscribe(
                        exitoCambioProveedor => {

                          if (exitoCambioProveedor) {
                            this.resultadoCambioEstado(success);

                            if (!this.isDocoutUser) {
                              this.router.navigate(['docout', { outlets: { contenido: ['panelmando'] } }]);
                            } else {
                              this.getDetailsSolicitud();
                            }
                          } else {
                            // Fallo al cambiar el proveedor, aunque creo que lo controlo en el subcribe
                            this.accionesSiFalla('No se pudo cambiar el proveedor', 'mensajes.stateSituationNotModify', 'mensajes.incorrectModification');
                            return;
                          }
                        },
                        // Error de cambio Proveedor
                        errorCode => {
                          this.accionesSiFalla(errorCode, 'mensajes.stateSituationNotModify', 'mensajes.incorrectModification');
                        });
                  },
                    errorCode => {
                      this.accionesSiFalla(errorCode, 'mensajes.stateSituationNotModify', 'mensajes.incorrectModification');
                    }
                  );
              } else {

                // Si no es necesaraio que cambie de estado, cambio el proveedor y genero una traza ficticia
                this.proveedoresService.ActualizarIdProveedorSolicitud(this.id, estadoCambio.IdProveedorDestino,
                  'Cambio de proveedor automatico', 'Cambio de proveedor automatico').subscribe(
                    exitoCambioProveedor => {
                      if (exitoCambioProveedor) {
                        this.estadosService.CrearTrazaCambioEstadoAutomaticoDocout(this.id, this.viewDetails.ID_ESTADO_DOCOUT,
                          this.viewDetails.ID_SITUACION_DOCOUT, this.idestado, this.idsituacion).subscribe(exito => {
                            if (!this.isDocoutUser) {
                              this.router.navigate(['docout', { outlets: { contenido: ['panelmando'] } }]);
                            } else {
                              this.getDetailsSolicitud();
                            }
                          }, errores => {
                            this.accionesSiFalla('No se pudo crear la traza', 'mensajes.stateSituationNotModify', 'mensajes.incorrectModification');
                          });
                      } else {
                        // Fallo al cambiar el proveedor, aunque creo que lo controlo en el subcribe
                        this.accionesSiFalla('No se pudo cambiar el proveedor', 'mensajes.stateSituationNotModify', 'mensajes.incorrectModification');
                        return;
                      }
                    },
                    // Error de cambio Proveedor
                    errorCode => {
                      this.accionesSiFalla(errorCode, 'mensajes.stateSituationNotModify', 'mensajes.incorrectModification');
                    });

              }

            }, errorCode => {
              // error recuperando el cambio automatico
              this.accionesSiFalla(errorCode, 'mensajes.stateSituationNotModify', 'mensajes.incorrectModification');
              return;
            });

        } else {
          // Cambio el estado por el que indica el usuario
          this.detalleservice.updateEstadosSolicitud(this.estadosSolicitud)
            .subscribe(success => {
              this.resultadoCambioEstado(success);
            },
              errorCode => {
                this.accionesSiFalla(errorCode, 'mensajes.stateSituationNotModify', 'mensajes.incorrectModification');
              }
            );
        }
      }, errorCode => {
        // Error de tiene actualizacion
        this.accionesSiFalla(errorCode, 'mensajes.stateSituationNotModify', 'mensajes.incorrectModification');
      });

  }
  accionesSiFalla(errorCode, mensaje1: string, mensaje2: string) {
    this.thinking = false;
    this.statusCode = 500;
    this.revertirEstadosSolicitud();
    this.translateService.get(['mensajes']).subscribe(values => {
      if (errorCode.error != null) {
        this.toastr.warning(errorCode.error.Message, this.translateService.instant('mensajes.errorHappens'));
      } else {
        this.toastr.success(this.translateService.instant(mensaje1),
          this.translateService.instant(mensaje2));
      }
    });
  }

  resultadoCambioEstado(success: Boolean) {
    this.thinking = false;
    if (success) {
      this.toastr.success(this.translateService.instant('mensajes.stateSituationModify'),
        this.translateService.instant('mensajes.correctModification'));
      this.idestado_original = this.idestado;
      this.idsituacion_original = this.idsituacion;

      const stateRequest = this.cbEstado.find(cbState => cbState.ID == this.idestado);

      if (stateRequest.IsFinalize || stateRequest.IsCanceled) {
        this.getDetailsSolicitud();
        this.viewConta = null;
        this.requestConta = false;
        this.single_selected = undefined;
      }

    } else {
      this.toastr.success(this.translateService.instant('mensajes.stateSituationNotModify'),
        this.translateService.instant('mensajes.incorrectModification'));
      this.revertirEstadosSolicitud();
    }

  }
  updateEstadosContenido() {
    this.estadosContenido = [];
    this.estadosContenido.push(new ActualizaEstadosContenido());
    this.estadosContenido[0].ID_CONTENIDO = parseFloat(this.idcontenido);
    this.estadosContenido[0].ID_ESTADO = parseFloat(this.idEstContent.toString());
    this.estadosContenido[0].ID_SITUACION = parseFloat(this.idSitContent.toString());

    this.thinking = true;
    this.subscription_update = this.detalleservice.updateEstadosContenido(this.estadosContenido)
      .subscribe(success => {
        this.thinking = false;
        if (success) {
          this.toastr.success(this.translateService.instant('mensajes.stateSituationContentModify'),
            this.translateService.instant('mensajes.correctModification'));
          this.idEstContent_original = this.idEstContent;
          this.idSitContent_original = this.idSitContent;
          this.getDetailsSolicitud();

          const contentStateSelected = this.cbEstadoContenido.find(estCont => estCont.ID == this.idEstContent);
          if (contentStateSelected.IsFinalize) {
            this.single_selected.estadoId = this.idEstContent;
            this.single_selected.situacionId = this.idSitContent;
            // encontrar en this.rows, el registro que coincide con ID_CONTENIDO y pasarlo al Onselect ¿?¿?¿?¿?¿?¿?¿'
            // const elemento = this.rows.find(obj => obj.Id_Contenido == this.idcontenido);
            // this.onSelect(elemento);

            // con esto solo recarga combos, checks y demás
            // this.loadContabilidad();

          }
        } else {
          this.toastr.success(this.translateService.instant('mensajes.stateSituationContentNotModify'),
            this.translateService.instant('mensajes.correctModification'));
          this.revertirEstadosContenido();
        }
      },
        errorCode => {
          this.thinking = false;
          this.statusCode = 500;
          this.revertirEstadosContenido();
          this.translateService.get(['mensajes']).subscribe(values => {
            if (errorCode.error != null) {
              this.toastr.warning(errorCode.error.Message, 'Ha ocurrido un error');
            } else {
              this.toastr.success(this.translateService.instant('mensajes.stateSituationContentNotModify'),
                this.translateService.instant('mensajes.correctModification'));
            }
          });
        }
      );
  }

  updateCheck(target: string, descripcion: string) {

    const control = (<HTMLInputElement>document.getElementById('check_' + target));
    const identificador = target;
    const cantidad = control.checked ? 1 : 0;
    this.updateConcepto = [];
    this.updateConcepto.push(new ActualizaConcepto());
    this.updateConcepto[0].ID_CONTENIDO = parseInt(this.idcontenido, null);
    this.updateConcepto[0].ID_CONCEP_CONT_SERV = parseInt(target, null);
    this.updateConcepto[0].ID_CONC_CONT_TVAL = null;
    this.updateConcepto[0].CANTIDAD = cantidad;
    this.subscription_update = this.detalleservice.updateConcepto(this.updateConcepto)
      .subscribe(success => {
        if (success) {
          this.toastr.success('El concepto ' + descripcion + ' ha sido modificado correctamente', 'Correcto');
        } else {
          this.toastr.warning('No se ha podido modificar el concepto ' + descripcion, 'Incorrecto');
        }
      },
        errorCode => {
          control.checked = !control.checked;
          this.statusCode = 500;
          this.translateService.get(['mensajes'])
            .subscribe(values => {
              if (errorCode.error != null) {
                this.toastr.warning(errorCode.error.Message, this.translateService.instant('mensajes.errorHappens'));
              } else {
                // this.toastr.warning(values['mensajes']['nodata'], values['mensajes']['nodatatitle']);
                this.toastr.warning('No se ha podido modificar el concepto ' + descripcion, 'Incorrecto');
              }
            });
        }
      );
  }


  // endregion


  onSLAChange(fechalimite: string) {
    if (fechalimite && this.isDate(fechalimite) && this.isGreatherThan(fechalimite, this.viewDetails.FECHA_CREACION)) {
      fechalimite = this.datePipe.transform(fechalimite, 'yyyy-MM-ddTHH:mm:') + '00';
      const fechasla = new FechaSLA();
      this.limitDate = new Date(fechalimite);
      fechasla.FECHA_SLA = fechalimite;
      fechasla.ID_SOLICITUD = this.id;
      this.subscription_update = this.detalleservice.updateFechaSLA(fechasla)
        .subscribe(success => {
          if (success) {
            this.toastr.success('La fecha SLA ha sido modificada correctamente', 'Modificación correcta');
            this.viewDetails.FECHA_SLA = this.limitDate;
          } else {
            this.toastr.warning('No se ha podido modificar la fecha SLA', 'Modificación incorrecta');
            this.limitDate = this.viewDetails.FECHA_SLA;
          }
        },
          errorCode => {
            this.limitDate = this.viewDetails.FECHA_SLA;
            this.statusCode = 500;
            this.translateService.get(['mensajes']).subscribe(values => {
              if (errorCode.error != null) {
                this.toastr.warning(errorCode.error.Message, 'Ha ocurrido un error');
              } else {
                this.toastr.warning('No se ha podido modificar la fecha SLA ', 'Modificación incorrecta');
              }
            });
          });
    } else {
      this.showErrorDateToastr(fechalimite, this.viewDetails.FECHA_CREACION, 'mensajes.dateLesserCreationDate');
      this.limitDate = this.viewDetails.FECHA_SLA ? this.viewDetails.FECHA_SLA : null;
    }
  }

  setEntryDate(entryDate: string) {
    if (entryDate && this.isDate(entryDate) && this.isGreatherThan(entryDate, this.single_selected.fechaFinalizacion)) {
      entryDate = this.datePipe.transform(entryDate, 'yyyy-MM-ddTHH:mm:') + '00';
      const fechaContenidos = new FechaContenidos();
      this.entryDateContent = new Date(entryDate);
      fechaContenidos.DATE = entryDate;
      fechaContenidos.IDS_CONTENIDOS = [this.single_selected.contenidoId];
      this.detalleservice.updateFechaEntradaContenidos(fechaContenidos)
        .subscribe(success => {
          if (success) {
            this.toastr.success(this.translateService.instant('mensajes.entryDateModify'),
              this.translateService.instant('mensajes.correctModification'));
            this.single_selected.fechaEntrada = this.entryDateContent;
          } else {
            this.toastr.warning(this.translateService.instant('mensajes.errorEntryDate'),
              this.translateService.instant('mensajes.incorrectModification'));
            this.entryDateContent = this.single_selected.fechaEntrada;
          }
        },
          errorCode => {
            this.entryDateContent = this.single_selected.fechaEntrada;
            this.statusCode = 500;
            if (errorCode.error != null) {
              this.toastr.warning(errorCode.error.Message, this.translateService.instant('mensajes.errorHappens'));
            } else {
              this.toastr.warning(this.translateService.instant('mensajes.errorEntryDate'),
                this.translateService.instant('mensajes.incorrectModification'));
            }
          });
    } else {
      this.showErrorDateToastr(entryDate, this.single_selected.fechaFinalizacion, 'mensajes.dateLesserFinishDateContent');
      this.entryDateContent = this.single_selected.fechaEntrada ? this.single_selected.fechaEntrada : null;
    }
  }

  setExpirationDate(expirationDate: string) {
    if (expirationDate && this.isDate(expirationDate) && this.isGreatherThan(expirationDate, this.single_selected.fechaFinalizacion)) {
      expirationDate = this.datePipe.transform(expirationDate, 'yyyy-MM-ddTHH:mm:') + '00';
      const fechaContenidos = new FechaContenidos();
      this.expirationDateContent = new Date(expirationDate);
      fechaContenidos.DATE = expirationDate;
      fechaContenidos.IDS_CONTENIDOS = [this.single_selected.contenidoId];
      this.detalleservice.updateFechaExpiracionContenidos(fechaContenidos)
        .subscribe(success => {
          if (success) {
            const content = this.getContentByIdContents(this.single_selected.contenidoId);
            content.fechaExpiracion = this.expirationDateContent;
            this.toastr.success(this.translateService.instant('mensajes.expirationDateModify'),
              this.translateService.instant('mensajes.correctModification'));
            this.single_selected.fechaEntrada = this.entryDateContent;
          } else {
            this.toastr.warning(this.translateService.instant('mensajes.errorExpirationDate'),
              this.translateService.instant('mensajes.incorrectModification'));
            this.entryDateContent = this.single_selected.fechaEntrada;
          }
        },
          errorCode => {
            this.entryDateContent = this.single_selected.fechaEntrada;
            this.statusCode = 500;
            if (errorCode.error != null) {
              this.toastr.warning(errorCode.error.Message, this.translateService.instant('mensajes.errorHappens'));
            } else {
              this.toastr.warning(this.translateService.instant('mensajes.errorExpirationDate'),
                this.translateService.instant('mensajes.incorrectModification'));
            }
          });
    } else {
      this.showErrorDateToastr(expirationDate, this.single_selected.fechaFinalizacion, 'mensajes.dateLesserFinishDateContent');
      this.expirationDateContent = this.single_selected.fechaExpiracion ? this.single_selected.fechaExpiracion : null;
    }
  }


  private showErrorDateToastr(date: string, compareLesserDate: Date, textCompareProblemKey: string): any {
    if (!date || !this.isDate(date)) {
      this.toastr.warning(this.translateService.instant('mensajes.incorrectDate'), this.translateService.instant('mensajes.incorrectModification'));
    } else if (!this.isGreatherThan(date, compareLesserDate)) {
      this.toastr.warning(this.translateService.instant(textCompareProblemKey),
        this.translateService.instant('mensajes.incorrectModification'));
    }
  }

  setRealEndDate(realEndDate: string) {
    if (realEndDate && this.isDate(realEndDate) && this.isGreatherThan(realEndDate, this.single_selected.fechaFinalizacion)) {
      realEndDate = this.datePipe.transform(realEndDate, 'yyyy-MM-ddTHH:mm:') + '00';
      const fechaContenidos = new FechaContenidos();
      this.realEndDateContent = new Date(realEndDate);
      fechaContenidos.DATE = realEndDate;
      fechaContenidos.IDS_CONTENIDOS = [this.single_selected.contenidoId];
      this.detalleservice.updateFechaRealFinalizacionContenidos(fechaContenidos)
        .subscribe(success => {
          if (success) {
            this.toastr.success(this.translateService.instant('mensajes.realEndDateModify'),
              this.translateService.instant('mensajes.correctModification'));
            this.single_selected.fechaRealFin = this.realEndDateContent;
          } else {
            this.toastr.warning(this.translateService.instant('mensajes.errorRealEndDate'),
              this.translateService.instant('mensajes.incorrectModification'));
            this.realEndDateContent = this.single_selected.fechaRealFin;
          }
        },
          errorCode => {
            this.realEndDateContent = this.single_selected.fechaRealFin;
            this.statusCode = 500;
            if (errorCode.error != null) {
              this.toastr.warning(errorCode.error.Message, this.translateService.instant('mensajes.errorHappens'));
            } else {
              this.toastr.warning(this.translateService.instant('mensajes.errorRealEndDate'),
                this.translateService.instant('mensajes.incorrectModification'));
            }
          });
    } else {
      this.showErrorDateToastr(realEndDate, this.single_selected.fechaFinalizacion, 'mensajes.dateLesserFinishDateContent');
      this.realEndDateContent = this.single_selected.fechaFinalizacion ? this.single_selected.fechaFinalizacion : null;
    }
  }

  massiveEndedRealEndDate(massiveRealEndDate: string) {
    if (massiveRealEndDate && this.isDate(massiveRealEndDate) && this.isGreatherThan(massiveRealEndDate, this.viewDetails.FECHA_FINALIZACION)) {
      massiveRealEndDate = this.datePipe.transform(massiveRealEndDate, 'yyyy-MM-ddTHH:mm:') + '00';
      const fechaContenidos = new FechaContenidos();
      this.realEndDateMassive = new Date(massiveRealEndDate);
      fechaContenidos.DATE = massiveRealEndDate;
      const contents = this.getAllIdContents();
      fechaContenidos.IDS_CONTENIDOS = contents;
      this.detalleservice.updateFechaRealFinalizacionContenidos(fechaContenidos)
        .subscribe(success => {
          this.fechaFinalizacionMassiveRows = this.realEndDateMassive;
          if (this.single_selected) {
            this.realEndDateContent = this.realEndDateMassive;
          }
          this.realEndDateMassive = null;
          if (success) {
            this.toastr.success(this.translateService.instant('mensajes.realEndDateMassiveModify'),
              this.translateService.instant('mensajes.correctModification'));
          } else {
            this.toastr.warning(this.translateService.instant('mensajes.errorRealEndMassiveDate'),
              this.translateService.instant('mensajes.incorrectModification'));
          }
        },
          errorCode => {
            this.realEndDateMassive = null;
            this.statusCode = 500;
            if (errorCode.error != null) {
              this.toastr.warning(errorCode.error.Message, this.translateService.instant('mensajes.errorHappens'));
            } else {
              this.toastr.warning(this.translateService.instant('mensajes.errorRealEndMassiveDate'),
                this.translateService.instant('mensajes.incorrectModification'));
            }
          });
    } else {
      this.showErrorDateToastr(massiveRealEndDate, this.viewDetails.FECHA_FINALIZACION, 'mensajes.dateLesserFinishDateContent');
      this.realEndDateMassive = null;
    }
  }

  massiveEntryDate(entryDateMassive: string) {
    if (entryDateMassive && this.isDate(entryDateMassive) && this.isGreatherThan(entryDateMassive, this.viewDetails.FECHA_FINALIZACION)) {
      entryDateMassive = this.datePipe.transform(entryDateMassive, 'yyyy-MM-ddTHH:mm:') + '00';
      const fechaContenidos = new FechaContenidos();
      this.entryDateMassive = new Date(entryDateMassive);
      fechaContenidos.DATE = entryDateMassive;
      const contents = this.getAllIdContents();
      fechaContenidos.IDS_CONTENIDOS = contents;
      this.detalleservice.updateFechaEntradaContenidos(fechaContenidos)
        .subscribe(success => {
          this.fechaEntradaMassiveRows = this.entryDateMassive;
          if (this.single_selected) {
            this.entryDateContent = this.entryDateMassive;
          }
          this.entryDateMassive = null;
          if (success) {
            this.toastr.success(this.translateService.instant('mensajes.entryDateMassiveModify'),
              this.translateService.instant('mensajes.correctModification'));
          } else {
            this.toastr.warning(this.translateService.instant('mensajes.errorEntryDateMassive'),
              this.translateService.instant('mensajes.incorrectModification'));
          }
        },
          errorCode => {
            this.entryDateMassive = null;
            this.statusCode = 500;
            if (errorCode.error != null) {
              this.toastr.warning(errorCode.error.Message, this.translateService.instant('mensajes.errorHappens'));
            } else {
              this.toastr.warning(this.translateService.instant('mensajes.errorEntryDateMassive'),
                this.translateService.instant('mensajes.incorrectModification'));
            }
          });
    } else {
      this.showErrorDateToastr(entryDateMassive, this.viewDetails.FECHA_FINALIZACION, 'mensajes.dateLesserFinishDateContent');
      this.entryDateMassive = null;
    }
  }

  private isGreatherThan(greatherDate: string, lesserDate: Date) {
    return new Date(lesserDate) <= new Date(greatherDate);
  }

  private isDate(fechalimite: string): boolean {
    return <any>fechalimite instanceof Date;
  }

  // region "Change events"
  // region "Cambios de estados glboales de la solicitud"
  onSituacionChange(idsituacion: number) {
    if ((idsituacion !== null && idsituacion > -1) && (this.idsituacion != this.idsituacion_original)) {
      const newSituation = this.cbSituacion.find(sit => sit.SITUACION.Id == idsituacion);
      if ((newSituation.IsFinalize || newSituation.IsCanceled) && !this.isMaterialsRequest()) {
        if (!this.cbEstadoContenido) {
          this.subscription_state = this.populateService.getComboEstadoContenido(this.viewDetails.ID_CLIENTE, this.viewDetails.ID_TIPO_SERVICIO)
            .subscribe(
              estados => {
                this.cbEstadoContenido = estados;
                this.manageSituationFinish(newSituation);
              },
              errorCode => {
                this.cbEstadoContenido = [];
                this.errorCode();
              });
          return;
        }
        this.manageSituationFinish(newSituation);
      } else {

        this.modificaSituacionSolicitud();
      }
    } else {

    }
  }
  private manageSituationFinish(newSituation: SituacionSolicitud) {
    if (newSituation.IsFinalize) {
      this.finalizeStateRequest();
    } else {
      this.cancelStateRequest();
    }
  }
  private finalizeStateRequest() {

    if (!this.hasAnyContentWithoutFinishState()) {
      const mensaje = '<div class="callout callout-warning text-uppercase">'
        + this.translateService.instant('mensajes.messagenotfinishrequest')
        + '<br /> ' + this.translateService.instant('mensajes.messagecheckall') + '</div>';
      this.finalizaSolicitud(mensaje, 'mensajes.endRequest', 'mensajes.markEndedRequestNotify');
    } else {
      this.idEstContentMasiva = this.cbEstadoContenido.find(est => est.IsFinalize).ID;
      this.putEstadoContenidoMasivo(true);
      this.openAviso(this.template_aviso);
    }
  }

  private cancelStateRequest() {
    if (this.hasAnyContentWithFinishState()) {
      this.showMessageCancelRequestNotAllowed();
    } else {
      if (this.hasAnyContentWithoutFinishState() && !this.hasAllContentsCancelState()) {
        this.idEstContentMasiva = this.cbEstadoContenido.find(est => est.IsCanceled).ID;
        this.putEstadoContenidoMasivo(false);
        this.openAviso(this.templateCancel);
      } else {
        const mensaje = '<div class="callout callout-warning text-uppercase">'
          + this.translateService.instant('mensajes.messagenotCancelrequest')
          + '<br /> ' + this.translateService.instant('mensajes.messagecheckall') + '</div>';
        this.finalizaSolicitud(mensaje, 'mensajes.cancelRequest', 'mensajes.markCanceledRequestNotify');
      }
    }
  }

  private showMessageCancelRequestNotAllowed() {
    this.toastr.error(this.translateService.instant('mensajes.cancelRequestWithFinalizeContentNotAllowed'));
  }

  private putEstadoContenidoMasivo(isFinalize: boolean) {
    if (this.allSituacionesContenido) {
      const situations = isFinalize ? this.allSituacionesContenido.filter(situacionContenido => situacionContenido.IsFinalize)
        : this.allSituacionesContenido.filter(situacionContenido => situacionContenido.IsCanceled);
      this.cbSituacionMasiva = situations.map(situacionContenido => situacionContenido.SITUACION);
      return;
    }

    this.idEstContent = isFinalize ? this.cbEstadoContenido.find(estCont => estCont.IsFinalize).ID
      : this.cbEstadoContenido.find(estCont => estCont.IsCanceled).ID;
    this.getSituacionContenido(this.viewDetails.ID_TIPO_SERVICIO);
  }

  private hasAllContentsCancelState(): boolean {
    const statesCancelled = this.cbEstado.filter(est => est.IsCanceled);
    const hasAnyContentWithoutFinishStateNoInventories = this.hasAllContentsCancelled(this.rowsContenidosNoInventariados, statesCancelled);
    const hasAnyContentWithoutFinishStateRecords = this.hasAllContentsCancelled(this.rowsContenidosExpedientes, statesCancelled);
    const hasAnyContentWithoutFinishStateContainers = this.hasAllContentsCancelled(this.rowsContenidosContenedores, statesCancelled);
    const hasAnyContentWithoutFinishStateAZs = this.hasAllContentsCancelled(this.rowsContenidosAZs, statesCancelled);
    return hasAnyContentWithoutFinishStateNoInventories
      || hasAnyContentWithoutFinishStateRecords
      || hasAnyContentWithoutFinishStateContainers
      || hasAnyContentWithoutFinishStateAZs;
  }

  private hasAllContentsCancelled(rows: TableContentInfo[], statesCancelled: ComboEstado[]): boolean {
    if (!this.hasContentTable(rows)) { return false; }
    return !rows.some(row => !this.hasCancelledContent(statesCancelled, row));
  }
  private hasCancelledContent(statesCancelled: ComboEstado[], content: TableContentInfo): boolean {
    const stateContent = statesCancelled.find(stateCancelled => stateCancelled.ID == content.estadoId);
    return stateContent && stateContent.IsCanceled;
  }

  private hasAnyContentWithoutFinishState(): any {
    const statesFinalizes = this.cbEstado.filter(est => est.IsFinalize);
    const hasAnyContentWithoutFinishStateNoInventories = this.hasAnyContentWithoutFinalize(this.rowsContenidosNoInventariados, statesFinalizes);
    const hasAnyContentWithoutFinishStateRecords = this.hasAnyContentWithoutFinalize(this.rowsContenidosExpedientes, statesFinalizes);
    const hasAnyContentWithoutFinishStateContainers = this.hasAnyContentWithoutFinalize(this.rowsContenidosContenedores, statesFinalizes);
    const hasAnyContentWithoutFinishStateAZs = this.hasAnyContentWithoutFinalize(this.rowsContenidosAZs, statesFinalizes);
    return hasAnyContentWithoutFinishStateNoInventories
      || hasAnyContentWithoutFinishStateRecords
      || hasAnyContentWithoutFinishStateContainers
      || hasAnyContentWithoutFinishStateAZs;
  }

  private hasAnyContentWithFinishState(): any {
    const statesFinalizes = this.cbEstado.filter(est => est.IsFinalize);
    const hasAnyContentWithFinishStateNoInventories = this.rowsContenidosNoInventariados
      .some(row => statesFinalizes.some(finalState => finalState.ID == row.estadoId));
    const hasAnyContentWithFinishStateRecords = this.rowsContenidosExpedientes
      .some(row => statesFinalizes.some(finalState => finalState.ID == row.estadoId));
    const hasAnyContentWithFinishStateContainers = this.rowsContenidosContenedores
      .some(row => statesFinalizes.some(finalState => finalState.ID == row.estadoId));
    const hasAnyContentWithFinishStateAZs = this.rowsContenidosAZs
      .some(row => statesFinalizes.some(finalState => finalState.ID == row.estadoId));
    return hasAnyContentWithFinishStateNoInventories
      || hasAnyContentWithFinishStateRecords
      || hasAnyContentWithFinishStateContainers
      || hasAnyContentWithFinishStateAZs;
  }
  private hasAnyContentWithoutFinalize(tableInfo: TableContentInfo[], statesFinalizes: ComboEstado[]): boolean {
    return this.hasContentTable(tableInfo) && tableInfo.some(content => this.hasContentWithoutFinishState(statesFinalizes, content));
  }
  private hasContentTable(tableInfo: TableContentInfo[]) {
    return tableInfo && tableInfo.length > 0 && tableInfo.some(table => table.campos && Object.keys(table.campos).length > 0);
  }
  private hasContentWithoutFinishState(statesFinalizes: ComboEstado[], content: TableContentInfo): boolean {
    return !statesFinalizes.some(statesFinalize => statesFinalize.ID == content.estadoId);
  }

  modificaSituacionSolicitud() {
    const modal = this.modalservice.show(ModalConfirmationComponent, { backdrop: 'static', keyboard: false });
    (<ModalConfirmationComponent>modal.content).showConfirmationModal(
      'Cambiar situación',
      'Va a cambiar la situación de la solicitud. <br />  ¿Está usted seguro/a?',
      '',
      'Si',
      'No',
      true,
      'fa-info-circle fa-3x',
      'bg-primary'
    );
    (<ModalConfirmationComponent>modal.content).onClose.subscribe(result => {
      if (result === true) {
        // when pressed Yes
        this.updateEstadosSolicitud();
      } else if (result === false) {
        // when pressed No
        this.revertirEstadosSolicitud();

      } else {
        // When closing the modal without no or yes (Esc or click outside)
        // removed close with ESC (keyboard:false) and click outside(backdrop static)
        // in modal config (this function it`s not neccesary, ins´t it???)
        this.revertirEstadosSolicitud();
      }
    });
  }

  openAviso(template: TemplateRef<any>) {
    this.modalRef = this.modalservice.show(template, { backdrop: 'static', keyboard: false });
    this.modalservice.onHide.subscribe(() => {
      this.revertirEstadosSolicitud();
    });
  }

  closeAviso() {
    this.idEstContentMasiva = -1;
    this.idSituacionMasiva = -1;
    this.showSituationMassiveYesButton = false;
    this.modalRef.hide();
  }

  showModalCargaMasiva() {
    const modalRef = this.modalservice
      .show(CargaMasivaComponent, { class: 'modal-dialog modal-lg', initialState: { templateId: this.templateId, autoLoad: false } });
    (<CargaMasivaComponent>modalRef.content).onClose.subscribe((result: MassiveLoadResult) => {
      if (result) {
        this.addNewContents(result.registrosExcel);
      }
    }, error => {
      this.toastr.error('No ha sido posible realizar la operación. Por favor, inténtelo de nuevo más tarde.');
    });
    (<CargaMasivaComponent>modalRef.content).onFileUploaded.pipe(first()).subscribe((fileData: FileData) => {
      if (fileData) {
        this.loading = true;
        this.fileManagerService.uploadFileToRepository(fileData.file, false, FileType.CARGA_MASIVA).pipe(first())
          .subscribe(guid => {
            this.fileManagerService.associateFileToRequest(this.id, guid).pipe(first())
              .subscribe(() => {
                this.getDetailsSolicitud();
                this.loading = false;
              },
                error => {
                  this.toastr.error('No ha sido posible asociar el fichero a la solicitud. Por favor, inténtelo de nuevo más tarde.');
                  this.loading = false;
                });
          }, error => {
            this.toastr.error('No ha sido posible cargar el fichero. Por favor, inténtelo de nuevo más tarde.');
            this.loading = false;
          });
      }
    });
  }

  addNewContents(registrosExcel: MassiveLoadExcelField[][]) {
    const observables: Observable<number>[] = [];
    registrosExcel.forEach((registro: MassiveLoadExcelField[]) => {
      const contentToAttach: ValorCampoSerie[] = [];
      registro.filter(campo => campo.valor)
        .forEach((campo: MassiveLoadExcelField) => contentToAttach.push(new ValorCampoSerie(campo.nombreCampo, campo.valor, campo.id)));
      observables.push(
        this.seriesService.addValores(this.viewDetails.ID_SERIE, this.viewDetails.ID_SERVICIO, contentToAttach)
          .pipe(catchError((response: Response) => of(-1))
          ));
    });
    if (observables.length > 0) {
      this.requestProcessing = true;
      let output = observables[0];
      for (let x = 1; x < observables.length; x++) {
        output = concat(output, observables[x]);
      }
      let indiceEjecucion = 0;
      const erroneos = [];
      output.subscribe(resultSecuencial => {
        if (resultSecuencial > 0) {
          if (console) {
          }
          if (indiceEjecucion === observables.length - 1) {
            this.loading = false;
          }
        } else {
          erroneos.push(indiceEjecucion);
        }
        if (indiceEjecucion === observables.length - 1) {
          this.getDetailsSolicitud();
          this.requestProcessing = false;
          if (erroneos.length > 0) {
            this.toastr.error('Ha ocurrido un error asociando los nuevos contenidos a la solicitud. Por favor, '
              + 'inténtelo de nuevo más tarde.');
          }
        }
        indiceEjecucion++;
      });
    }
  }

  finalizaSolicitud(mensaje: string, titleTranslate: string, adviceTranslate: string) {
    const modal = this.modalservice.show(ModalConfirmationComponent, { backdrop: 'static', keyboard: false });
    (<ModalConfirmationComponent>modal.content).showConfirmationModal(
      this.translateService.instant(titleTranslate),
      this.translateService.instant(adviceTranslate),
      mensaje,
      this.translateService.instant('generales.si'),
      this.translateService.instant('generales.no'),
      true,
      'fa-exclamation-triangle fa-3x',
      'bg-warning'
    );
    (<ModalConfirmationComponent>modal.content).onClose.subscribe(result => {
      this.finalizeRequest(result);
    });
  }

  private finalizeRequest(option: boolean) {
    if (option === true) {
      this.updateEstadosSolicitud();
    } else {
      this.revertirEstadosSolicitud();

    }
  }


  onEstadoChange(idestado: number) {
    if (idestado !== null && idestado > -1) {
      this.cbSituacion = this.allSituaciones.filter(situacion => situacion.ESTADO.Id == idestado);
    } else {
      this.cbSituacion = [];
    }
  }

  revertirEstadosSolicitud() {
    this.idestado = this.idestado_original;
    this.idsituacion = this.idsituacion_original;
    this.idEstContent = this.idEstContent_original;
    this.onEstadoChange(this.idestado);
  }
  // endregion

  eventCambioConsultas(event) {
    this.consultas = event.cantidadConsultas;
    this.consultasLocalizadas = event.cantidadLocalizadas;
    this.consultasNoLocalizadas = event.cantidadNoLocalizadas;
  }

  // region "Estado del contenido"
  onSituacionContenidoChange(idsituacion: number) {
    // Cada vez que cambiemos la situación de algún contenido debemos pedirle al usuario que lo confirme
    // y comprobar que la situación elegida no es la misma que la que ya teniamos

    if ((idsituacion !== null && idsituacion > -1) && (this.idSitContent != this.idSitContent_original)) {
      const contentStateSelected = this.cbEstadoContenido.find(est => est.ID == this.idEstContent);
      if ((contentStateSelected.IsCanceled || contentStateSelected.IsIncidencia) &&
        this.consultasLocalizadas > 0) {
        // 🐱‍👤 En este caso está realizando un cambio de estado a una incidencia o una cancelación
        // cuando el contenido tiene consultas localizadas, es un error de procedimiento, hay que avisar al usuario
        // que antes de realizar el cambio de estado tiene que poner las consultas como no localizadas
        this.toastr.warning(
          'Estas intentando cambiar el estado de un contenido cuando éste tiene consultas localizadas (' + this.consultasLocalizadas + '),' +
          'debes cambiar primero el estado de las consultas a \"No Localizadas\" antes de cambiar el estado del contenido',
          'Error de procedimiento'
        );
        return;
      }
      if (contentStateSelected.IsFinalize || contentStateSelected.IsCanceled) {
        this.finalizaContenido(contentStateSelected);
      } else {
        this.modificaSituacionContenido();
      }
    } else {

    }
  }

  onSituacionMasivaChange(idsituacionMasiva: number) {
    this.showSituationMassiveYesButton = idsituacionMasiva !== null && idsituacionMasiva > -1;
  }
  modificaSituacionContenido() {
    const modal = this.modalservice.show(ModalConfirmationComponent, { backdrop: 'static', keyboard: false });
    (<ModalConfirmationComponent>modal.content).showConfirmationModal(
      'Cambiar situación',
      'Va a cambiar la situación del contenido. <br /> ¿Está usted seguro/a?',
      '',
      this.translateService.instant('generales.si'),
      this.translateService.instant('generales.no'),
      true,
      'fa-exclamation-triangle fa-3x',
      'bg-primary'
    );
    (<ModalConfirmationComponent>modal.content).onClose.subscribe(result => {
      if (result === true) {
        this.updateEstadosContenido();
      } else {
        this.revertirEstadosContenido();
      }
    });
  }

  finalizaContenido(contentState: ComboEstado) {
    const header = contentState.IsFinalize ? 'mensajes.endContent' : 'mensajes.cancelContent';
    const message = contentState.IsFinalize ? 'mensajes.markEndedContentNotify' : 'mensajes.markCancelledContentNotify';
    const modal = this.modalservice.show(ModalConfirmationComponent, { backdrop: 'static', keyboard: false });
    (<ModalConfirmationComponent>modal.content).showConfirmationModal(
      this.translateService.instant(header),
      this.translateService.instant(message),
      '<div class="callout callout-warning text-uppercase">' + this.translateService.instant('mensajes.checkContentAllCorrect') + '</div>',
      this.translateService.instant('generales.si'),
      this.translateService.instant('generales.no'),
      true,
      'fa-exclamation-triangle fa-3x',
      'bg-warning'
    );
    (<ModalConfirmationComponent>modal.content).onClose.subscribe(result => {
      if (result === true) {
        this.updateEstadosContenido();

      } else {
        this.revertirEstadosContenido();
      }
    });
  }


  onEstadoContenidoChange(idestadocontenido: number) {
    if (idestadocontenido !== null && idestadocontenido > -1) {
      this.cbSituacionContenido = this.allSituacionesContenido.filter(situacionContenido => situacionContenido.ESTADO.Id == idestadocontenido)
        .map(situacionContenido => situacionContenido.SITUACION);
    } else {
      this.cbSituacionContenido = [];
    }
  }

  revertirEstadosContenido() {
    this.idEstContent = this.idEstContent_original;
    this.idSitContent = this.idSitContent_original;
    this.onEstadoContenidoChange(this.idEstContent);
  }


  // region "General"

  preProcessContabilidad(mensaje: string) {
    this.mensajeToShowConta = mensaje;
    this.statusCode = null;
    this.requestConta = true;
  }

  preProcessDetails(mensaje: string) {
    this.mensajeToShow = mensaje;
    this.statusCode = null;
    this.requestProcessing = true;
  }

  preProcessContent(mensaje: string) {
    this.mensajeToShow2 = mensaje;
    this.statusCode = null;
    this.requestContent = true;
  }


  errorCode() {
    this.statusCode = 500;
    this.translateService.get(['mensajes'])
      .subscribe(values => {
        this.toastr.warning(values['mensajes']['nodata'],
          values['mensajes']['nodatatitle']);
      });
    this.router.navigate(['/notfound']);
  }

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    const target = event.target || event.srcElement || event.currentTarget;
    const idAttr = target.id;

    if (idAttr != null) {
      if (charCode === 13) { // Enter} //check if ESC (27) for cancel
        const button = (<HTMLButtonElement>document.getElementById('btn_' + idAttr));
        if (button != null && !button.disabled) { button.click(); }
      } else {

        if (charCode == 64 || charCode == 16) {
          // to allow numbers
          return false;
        } else if (charCode >= 48 && charCode <= 57) {
          // to allow numbers
          return true;
        } else if (charCode >= 96 && charCode <= 105) {
          // to allow numpad number
          return true;
        } else if ([8, 9, 27, 37, 38, 39, 40].indexOf(charCode) > -1) {
          // to allow backspace, escape, arrows, tab, etc
          return true;
        } else {
          event.preventDefault();
          // to stop others
          return false;
        }

        // if (charCode > 31 && (charCode < 48 || charCode > 57)) { return false; }
        // return true;
      }
    } else { return false; }
  }

  // endregion

  // region "Detalle"

  onSelectTab(data: TabDirective): void {
    switch (data.id) {
      case 'tabdetalle':
        break;
      case 'tabobservaciones':
        this.reloadObservations = !this.reloadObservations;
        break;
      case 'tabhistorico':
        this.reload = !this.reload;
        break;
      case 'tabAutorizacion':
        this.reloadAuthorization();
        break;
      default:
        break;
    }
  }
  // endregion

  private reloadAuthorization() {
    this.loadingAuthorizationTable = true;
    this.flujoAprobacionesService.getAllAprobaciones(this.id)
      .subscribe((response: FlujoAprobaciones[]) => {
        this.approvingUsers = this.sortFlujoAprobacionesByFechaAprobacion(response);
        this.approvingGroup = this.approvingGroup ? [...this.approvingGroup] : undefined;
        if (!this.approvingUsers.some(resp => !resp.APROBADA)) {
          if (this.viewDetails.ID_USUARIO_APROBACION && this.viewDetails.ID_USUARIO_APROBACION > 0) {
            const newApprovingFlow: FlujoAprobaciones = {
              APROBADA: null,
              USUARIO_SUPERVISION: this.viewDetails.USUARIO_APROBACION,
              FECHA_APROBACION: null,
              NOMBRE_USUARIO_SUPERVISION: this.viewDetails.NOMBREYAPES_USUARIO_APROBACION
            };

            this.approvingUsers = [...this.approvingUsers, newApprovingFlow];
          } else if (this.viewDetails.GRUPO_APROBACION) {
            const newApprovingGroupFlow: FlujoAprobaciones = {
              APROBADA: null,
              USUARIO_SUPERVISION: this.viewDetails.GRUPO_APROBACION.NOMBRE,
              FECHA_APROBACION: null,
              NOMBRE_USUARIO_SUPERVISION: this.viewDetails.GRUPO_APROBACION.DESCRIPCION,
              ID_USUARIO_SUPERVISION: this.viewDetails.RANGO_APROBACION
            };
            this.approvingGroup = [newApprovingGroupFlow];
          }
        }
      });
  }

  private sortFlujoAprobacionesByFechaAprobacion(response: FlujoAprobaciones[]): FlujoAprobaciones[] {
    return response.sort(function (a, b) {
      const dateA: any = new Date(a.FECHA_APROBACION);
      const dateB: any = new Date(b.FECHA_APROBACION);
      return dateA - dateB;
    });
  }


  // region "Select load gestion/facturación"
  onSelect(event) {
    if (!this.isMaterialsRequest()) {
      this.entryDateContent = undefined;
      this.realEndDateContent = undefined;
      this.expirationDateContent = undefined;
      this.loadContabilidad(event);
    }
  }

  resetSelect(reset: boolean) {
    if (reset) {
      this.entryDateContent = undefined;
      this.realEndDateContent = undefined;
      this.expirationDateContent = undefined;
      this.single_selected = undefined;
      this.viewConta = null;
    }
  }

  private loadContabilidad(row: TableContentInfo) {
    if (!this.requestConta && row) {
      this.single_selected = row;
      this.idcontenido = row.contenidoId.toString();
      this.isInventariado = row.isInventario;
      this.entryDateContent = row.fechaEntrada;
      this.realEndDateContent = row.fechaRealFin;
      this.expirationDateContent = row.fechaExpiracion;
      this.contenidoFiles = this.getContentImages(+this.idcontenido);
      this.contabilidad = [];
      this.getContabilidadDetails(row.estadoId, row.situacionId);

      // 🥑🥑 proveedor contenido
      if (row.proveedor == null) {
        this.isProveedorDocoutCont = true;
      } else {
        this.isProveedorDocoutCont = false;
        this.proveedorCont = row.proveedor;
        this.idProveedorCont = row.idProveedor;
        this.correoProveedorCont = row.correoProveedor;
        this.telefonoProveedorCont = row.telefonoProveedor;
        this.contactoProveedorCont = row.contactoProveedor;
        this.contenidoSeleccionadoMostrado = true;
        this.usuarioTienePermisoCambioProveedorCont(this.authService.getUserId(), this.idProveedorCont);
      }
      
    }
  }

  deleteComboOption(item: ContabilidadOptionValue, descripcion: string, comboid: number) {
    const indice = this.contabilidad.map(obj => obj.PARAM.Id).indexOf(item.Id);
    if (indice >= 0) {
      const elemento = this.contabilidad.find(obj => obj.PARAM.Id === item.Id);

      const modal = this.modalservice.show(ModalConfirmationComponent, { backdrop: 'static', keyboard: false });
      (<ModalConfirmationComponent>modal.content).showConfirmationModal(
        'Eliminar concepto',
        'Este concepto tiene una cantidad establecida y va a eliminarlo. <br />  ¿Está usted seguro/a?',
        '',
        'Si',
        'No',
        true,
        'fa-exclamation-triangle fa-3x',
        'bg-danger'
      );
      (<ModalConfirmationComponent>modal.content).onClose.subscribe(result => {
        if (result === true) {
          // when pressed Yes
          this.eliminarConceptoContable(parseInt(this.idcontenido, null), comboid, item.Id, 0, descripcion, indice);

        } else if (result === false) {
          // when pressed No
        } else {
          // When closing the modal without no or yes (Esc or click outside)
        }
      });
    }
  }


  saveComboOption(item: ContabilidadOption, comboid: number) {
    const button = (<HTMLInputElement>document.getElementById('btn_cant_' + item.PARAM.Id));

    if (!item.PARAM.cantidad || item.PARAM.cantidad <= 0) {
      this.toastr.warning('Debe introducir una cantidad para el concepto', 'Falta cantidad');
    } else {

      this.updateConcepto = [];
      this.updateConcepto.push(new ActualizaConcepto());
      this.updateConcepto[0].ID_CONTENIDO = parseInt(this.idcontenido, null);
      this.updateConcepto[0].ID_CONCEP_CONT_SERV = comboid;
      this.updateConcepto[0].ID_CONC_CONT_TVAL = item.PARAM.Id;
      this.updateConcepto[0].CANTIDAD = item.PARAM.cantidad;

      this.subscription_update = this.detalleservice.updateConcepto(this.updateConcepto)
        .subscribe(success => {
          button.disabled = success;
          if (success) {
            this.toastr.success('El concepto ' + item.PARAM.label + ' ha sido modificado correctamente a ' + item.PARAM.cantidad + ' unidades',
              'Modificación correcta');
          } else {
            this.toastr.warning('No se ha podido modificar el concepto ' + item.PARAM.label, 'Modificación incorrecta');
          }

        },
          errorCode => {
            button.disabled = false;
            this.statusCode = 500;
            this.translateService.get(['mensajes'])
              .subscribe(values => {
                if (errorCode.error != null) {
                  this.toastr.warning(errorCode.error.Message, 'Ha ocurrido un error');
                } else {
                  this.toastr.warning(values['mensajes']['nodata'], values['mensajes']['nodatatitle']);
                }
              });
          }
        );

    }
  }


  eliminarConceptoContable(IDCONTENIDO: number, ID_CONCEP_CONT_SERV: number,
    ID_CONC_CONT_TVAL: number, CANTIDAD: number, descripcion: string, indice: number) {
    this.updateConcepto = [];
    this.updateConcepto.push(new ActualizaConcepto());
    this.updateConcepto[0].ID_CONTENIDO = IDCONTENIDO;
    this.updateConcepto[0].ID_CONCEP_CONT_SERV = ID_CONCEP_CONT_SERV;
    this.updateConcepto[0].ID_CONC_CONT_TVAL = ID_CONC_CONT_TVAL;
    this.updateConcepto[0].CANTIDAD = CANTIDAD;

    this.subscription_update = this.detalleservice.updateConcepto(this.updateConcepto)
      .subscribe(success => {
        if (success) {
          this.toastr.success('El concepto ' + descripcion + ' ha sido eliminado correctamente', 'Eliminación correcta');
          this.contabilidad.splice(indice, 1);
        } else {
          this.toastr.warning('No se ha podido eliminar el concepto ' + descripcion, 'Eliminación incorrecta');
        }

      },
        errorCode => {
          //  control.checked = !control.checked;
          this.statusCode = 500;
          this.translateService.get(['mensajes'])
            .subscribe(values => {
              if (errorCode.error != null) {
                this.toastr.warning(errorCode.error.Message, 'Ha ocurrido un error');
              } else {
                this.toastr.warning(values['mensajes']['nodata'], values['mensajes']['nodatatitle']);
              }
            });
        }
      );
  }



  addComboOption(target: ContabilidadValor) {
    const comboSelected = parseInt(target.comboboxConceptoSelected, 10);
    if (this.contabilidad.length <= 0 || this.contabilidad.map(obj => obj.PARAM.Id).indexOf(comboSelected) < 0) {
      const contabilidadValorOption = target.VALORES_COMBO.find(x => x.Id == comboSelected);
      const contabilidadOption = this.getContabilidadOption(target.Id, contabilidadValorOption);
      this.contabilidad.push(contabilidadOption);
    }
  }

  public cancelComboOption(item: ContabilidadOptionValue) {
    item.cantidad = 0;
    const button = (<HTMLButtonElement>document.getElementById('btn_cant_' + item.Id));
    button.disabled = true;
  }

  public checkvalues(item: ContabilidadOptionValue): void {
    const button = (<HTMLButtonElement>document.getElementById('btn_cant_' + item.Id));
    button.disabled = !item.cantidad || item.cantidad == 0;
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalservice.show(template);
  }

  closeModal() {
    this.modalRef.hide();
  }

  aprobarSolicitud(approved: number) {
    this.thinking = true;
    this.solicitudeservice.aprobarSolicitud(this.id, approved)
      .subscribe((response: SolicitudesAprobadas) => {
        this.thinking = false;
        this.viewDetails.ID_USUARIO_APROBACION = response.ID_USUARIO_APROBACION;
        this.viewDetails.USUARIO_APROBACION = response.USUARIO_APROBACION;
        this.viewDetails.GRUPO_APROBACION = undefined;
        this.viewDetails.RANGO_APROBACION = undefined;
        this.approvingGroup = undefined;
        this.reloadAuthorization();
        this.getDetailsSolicitud();
        this.closeModal();
      }, error => {
        this.thinking = false;
      });
  }


  // endregion

  canUploadContents(): boolean {
    if (this.viewDetails && this.cbEstado && !this.isCancelled) {
      const estado = this.cbEstado.find(st => st.ID === +this.idestado_original);
      return this.viewDetails.NOMBRE_TIPO_SERVICIO !== 'MATERIALES' && estado.NOMBRE.toUpperCase() !== 'FINALIZADA';
    }
    return false;
  }

  associateFileToContent(guid: string) {
    if (this.contenidoFiles && this.contenidoFiles.length > 0) {
      this.contenidoFiles.forEach(file => this.fileManagerService.removeFileFromRepository(file.guid)
        .subscribe(() => {
          this.fileManagerService.associateFileToContent(+this.idcontenido, guid).subscribe(result => {
            if (result > 0) {
              this.getDetailsSolicitud();
            }
          });
        }));
    } else {
      this.fileManagerService.associateFileToContent(+this.idcontenido, guid).subscribe(result => {
        if (result > 0) {
          this.getDetailsSolicitud();
        }
      });
    }
  }

  replaceFileInContent(values: { oldGuid: string, newGuid: string }) {
    // Primero se elimina el original y despues asocia el nuevo
    this.contenidoFiles.forEach(file => this.fileManagerService.removeFileFromRepository(values.oldGuid)
      .subscribe(() => {
        this.addFileToContent(values.newGuid);
      }));
  }

  addFileToContent(guid: string) {
    this.fileManagerService.associateFileToContent(+this.idcontenido, guid).subscribe(result => {
      if (result > 0) {
        this.getDetailsSolicitud();
      }
    });
  }

  removeFilesToContent(guid: string) {
    if (this.contenidoFiles && this.contenidoFiles.length > 0) {
      this.contenidoFiles.forEach(file => this.fileManagerService.removeFileFromRepository(file.guid)
        .subscribe(() => {
          this.getDetailsSolicitud();
        }));
    } else {
      this.getDetailsSolicitud();
    }
  }

  finalizarContenidosYSolicitud() {
    this.loadingMassive = true;

    // Compruebo si tiene cambio automatico
    this.estadosService.getTieneCambioAutomaticoDocout(
      this.id, this.viewDetails.ID_DEPARTAMENTO, this.viewDetails.ID_SERIE, this.idestado,
      this.idsituacion, this.viewDetails.ID_PROVEEDOR).subscribe(tieneCambio => {
        // Si tiene cambio automatico, seguimos esta ruta:
        if (tieneCambio) {
          // Recupero el estado final
          this.estadosService.getObtenEstadoCambioAutomaticoDocout(
            this.id, this.viewDetails.ID_DEPARTAMENTO, this.viewDetails.ID_SERIE, this.idestado,
            this.idsituacion, this.viewDetails.ID_PROVEEDOR).subscribe(estado => {


              if (estado != null) {

                // Cambiar el estado si es necesario
                if (estado.IdEstadoDestino != null) {
                  this.detalleservice.finalizeRequestAndAllContents(this.id, estado.IdEstadoDestino, estado.IdSituacionDestino, this.idEstContentMasiva,
                    +this.idSituacionMasiva).subscribe(result => {
                      this.getDetailsSolicitud();
                      this.closeAviso();
                      this.loadingMassive = false;
                      // Redirijo al usuario fuera de la seccion de detalle de solicitud
                      if (!this.isDocoutUser) {
                        this.router.navigate(['docout', { outlets: { contenido: ['panelmando'] } }]);
                      } else {
                        this.getDetailsSolicitud();
                      }
                    },
                      // Error del cambio de estado
                      error => this.loadingMassive = false);
                }
                // Cambio el proveedor
                this.proveedoresService.ActualizarIdProveedorSolicitud(this.id, estado.IdProveedorDestino,
                  'Cambio de Proveedor Automatico por cierre', 'Cambio de Proveedor Automatico por cierre').subscribe(exito => {
                    if (exito) {
                      if (!this.isDocoutUser) {
                        this.router.navigate(['docout', { outlets: { contenido: ['panelmando'] } }]);
                      } else {
                        this.getDetailsSolicitud();
                      }
                    } else {
                      this.loadingMassive = false;
                    }
                  },
                    // Error al cambiar el proveedor
                    error => this.loadingMassive = false);
              }
            },
              // Errores de getObtenEstadoCambioAutomaticoDocout
              error => this.loadingMassive = false);
        } else {
          this.detalleservice.finalizeRequestAndAllContents(this.id, this.idestado, +this.idsituacion, this.idEstContentMasiva,
            +this.idSituacionMasiva).subscribe(result => {
              this.getDetailsSolicitud();
              this.closeAviso();
              this.loadingMassive = false;
            },
              error => this.loadingMassive = false);
        }
      },
        // Errores de getTieneCambioAutomaticoDocout
        error => this.loadingMassive = false);

  }

  downloadAlbaran() {
    this.downloadingAlbaran = true;
    this.albaranService.getAlbaranSolicitudBlob(this.id).subscribe(data => {
      const albaranBlob = new Blob([data], { type: 'application/pdf' });
      if (this.isIE) {
        window.navigator.msSaveOrOpenBlob(albaranBlob, this.id + '.pdf');
      } else {
        this.albaranBlobUrl = window.URL.createObjectURL(albaranBlob);
        this.downloadingAlbaran = false;
      }
    },
      error => {
        this.downloadingAlbaran = false;
      });
  }

  isServiceWithEntryDate() {
    return this.viewDetails.NOMBRE_TIPO_SERVICIO == 'ALTA'
      || this.viewDetails.NOMBRE_TIPO_SERVICIO == 'DEVOLUCION'
      || this.viewDetails.NOMBRE_TIPO_SERVICIO == 'INSERCION';
  }

  setContenidosNoInventariados(contenidosNoInventariados: TableContentInfo[]) {
    this.rowsContenidosNoInventariados = contenidosNoInventariados;
  }

  setContenidosExpedientes(contenidosExpedientes: TableContentInfo[]) {
    this.rowsContenidosExpedientes = contenidosExpedientes;
  }

  setContenidosContenedores(contenidosContenedores: TableContentInfo[]) {
    this.rowsContenidosContenedores = contenidosContenedores;
  }

  setContenidosAZs(contenidosAZs: TableContentInfo[]) {
    this.rowsContenidosAZs = contenidosAZs;
  }

  private getAllIdContents() {
    const idsRowsNoInventariadas = this.rowsContenidosNoInventariados.map(row => row.contenidoId);
    const idsRowsExpedientes = this.rowsContenidosExpedientes.map(row => row.contenidoId);
    const idsRowsContenedores = this.rowsContenidosContenedores.map(row => row.contenidoId);
    const idsRowsAZs = this.rowsContenidosAZs.map(row => row.contenidoId);

    return [].concat(idsRowsNoInventariadas, idsRowsExpedientes, idsRowsContenedores, idsRowsAZs);
  }

  private getContentByIdContents(contentId): TableContentInfo {
    const rowNoInventariadas = this.rowsContenidosNoInventariados.find(row => row.contenidoId == contentId);
    if (rowNoInventariadas) {
      return rowNoInventariadas;
    }
    const rowExpedientes = this.rowsContenidosExpedientes.find(row => row.contenidoId == contentId);
    if (rowExpedientes) {
      return rowExpedientes;
    }

    const rowContenedores = this.rowsContenidosContenedores.find(row => row.contenidoId == contentId);
    if (rowContenedores) {
      return rowContenedores;
    }

    const rowAZs = this.rowsContenidosAZs.find(row => row.contenidoId == contentId);
    if (rowAZs) {
      return rowAZs;
    }

    return null;
  }

  private hasContents() {
    if (this.isMaterialsRequest()) {
      return this.rowsContenidosNoInventariados && this.rowsContenidosNoInventariados.length > 0;
    }
    const hasDataNoInventariados = this.rowsContenidosNoInventariados && this.rowsContenidosNoInventariados.length > 0;
    const hasDataExpedientes = this.rowsContenidosExpedientes && this.rowsContenidosExpedientes.length > 0;
    const hasDataContenedores = this.rowsContenidosContenedores && this.rowsContenidosContenedores.length > 0;
    const hasDataAz = this.rowsContenidosAZs && this.rowsContenidosAZs.length > 0;
    return hasDataNoInventariados || hasDataExpedientes || hasDataContenedores || hasDataAz;
  }

  hasAllContents(hasAllContents: boolean) {
    if (hasAllContents) {
      this.noDataContent = !this.hasContents();
      this.thinking = false;
      this.requestContent = false;
      this.requestProcessing = false;
      this.isLoadingContents = false;
    } else {
      this.isLoadingContents = false;
    }
  }

  descargarDetalleSolicitud() {
    this.isLoadingContents = true;
    this.solicitudeservice.descargarDetalleSolicitud(this.id).pipe(first())
      .subscribe(data => {
        this.isLoadingContents = false;
        this.utilitiesService.downloadGenericFile(`${this.id}.pdf`, data);
      },
        error => {
          this.isLoadingContents = false;
          this.toastr.error(this.translateService.instant('solicitudes.detailDownloadError'));
        });
  }

  onResized(table, event: any): void {
    if (table) {
      setTimeout(() => {
        table.recalculate();
        window.dispatchEvent(new Event('resize'));
      }, (50));
    }
  }

  canRollbackClosed(): boolean {
    if (this.isGestorUser || (this.isDocoutUser && this.authService.isAdmin) || (!this.isDocoutUser && this.isProveedorUser)) {
      return true;
    } else {
      return false;
    }
  }

  rollBackSolicitud() {
    if (!this.canRollbackClosed()) {
      return;
    }
    this.solicitudeservice.rollbackSolicitudFinalizada(this.id)
      .subscribe(
        (r: boolean) => {
          this.toastr.success('Se ha realizado Rollback de la solicitud satisfactoriamente');
        },
        (e: Error) => {
          this.toastr.error('No se ha podido realizar Rollback de la solicitud => ' + e.message);
        },
        () => {
          this.getDetailsSolicitud();
        });
  }

  rollBackContenido(idcontenido: number) {
    if (!idcontenido || idcontenido <= 0) {
      return;
    }
    this.solicitudeservice.rollbackContenidoFinalizado(idcontenido)
      .subscribe(
        (r: boolean) => {
          this.toastr.success('Se ha realizado Rollback del contenido satisfactoriamente');
        },
        (e: Error) => {
          this.toastr.error('No se ha podido realizar Rollback del contenido => ' + e.message);
        },
        () => {
          this.getDetailsSolicitud();
        }
      );
  }

  tieneChecks(): boolean {
    return this.viewConta !== undefined && this.viewConta.filter(p => p.KEY === 'CHECK').length > 0;
  }

  removeFile(event) {
    this.loading = true;
    this.fileManagerService.removeFileFromRepository(event[0].guid)
      .subscribe(
        (p) => {
          if (p === 1) {
            this.toastr.success('Se ha eliminado correctamente el fichero del respositorio.');
          } else {
            this.toastr.warning('No se ha podido eliminar el fichero del respositorio. Vuelva a intentarlo más tarde o póngase en contacto con soporte');
          }
          this.loading = false;
          this.getDetailsSolicitud();
        },
        () => {
          this.toastr.error('Ha ocurrido un error al tratar de eliminar el fichero del respositorio.' +
            ' Vuelva a intentarlo más tarde o póngase en contacto con soporte');
          this.loading = false;
        }
      );
  }

  showModalChangeOptions() {

    const modal = this.modalservice.show(ChangeoptionsSolicitudComponent, { backdrop: 'static', keyboard: false });
    (<ChangeoptionsSolicitudComponent>modal.content).showConfirmationModal(
      'Cambiar opciones',
      'Seleccione los cambios que desea mediante los desplegables',
      this.id,
      this.tieneOriginalCopia,
      this.viewDetails.NORMAL_URGENTE == 'URGENTE',
      this.viewDetails.NOMBRE_PARAM_SERVICIO == 'ORIGINAL'
    );
    (<ChangeoptionsSolicitudComponent>modal.content).onClose.subscribe(result => {
      if (!result) {
        return;
      }
    });

    if (this.viewDetails.NORMAL_URGENTE == 'URGENTE') {
      this.esActualUrgente = true;
    } else {
      this.esActualUrgente = false;
    }
    if (this.viewDetails.NOMBRE_PARAM_SERVICIO == 'ORIGINAL') {
      this.esActualOriginal = true;
    } else {
      this.esActualOriginal = false;
    }
    (<ChangeoptionsSolicitudComponent>modal.content).onSaveCambios.subscribe(datos => {
      if (this.esActualUrgente != datos.normalurgente) {
        // cambios urgente normal
        this.solicitudeservice.actualizarUrgenteNormalSolicitud(this.id, datos.normalurgente)
          .subscribe(
            (p) => {
              this.toastr.success('Se ha actualizado el MODO de la solicitud.');
              if (this.esActualOriginal != datos.originalcopia) {
                // cambios original copia
                this.solicitudeservice.actualizarOriginalCopiaSolicitud(this.id, datos.originalcopia)
                  .subscribe(
                    (z) => {
                      // 🐱‍👤 Metodo para refrescar las opciones de la solicitud
                      this.toastr.success('Se ha actualizado el TIPO de la solicitud.');
                      this.getDetailsSolicitud();
                      this.loading = false;
                    },
                    (err: HttpErrorResponse) => {
                      // this.toastr.error('Ha ocurrido un problema al actualizar las opciones del servicio COPIA/ORIGINAL.' +
                      // ' Vuelva a intentarlo pasados unos segundos o póngase en contacto con soporte');
                      this.toastr.error('No se ha podido actualizar la solicitud, compruebe que sea un prestamo y vuelvalo a intentar en unos minutos.');
                      this.loading = false;
                    }
                  );
              }
              {
                this.getDetailsSolicitud();
                this.loading = false;
              }
            },
            (err: HttpErrorResponse) => {
              // this.toastr.error('Ha ocurrido un problema al actualizar las opciones del servicio NORMAL/URGENTE.' +
              //  ' Vuelva a intentarlo pasados unos segundos o póngase en contacto con soporte');
              this.toastr.error('No se ha podido actualizar la solicitud');
              this.loading = false;
            }
          );
      } else if (this.esActualOriginal != datos.originalcopia) {
        // cambios original copia
        this.solicitudeservice.actualizarOriginalCopiaSolicitud(this.id, datos.originalcopia)
          .subscribe(
            (z) => {
              // 🐱‍👤 Metodo para refrescar las opciones de la solicitud
              this.getDetailsSolicitud();
              this.toastr.success('Se ha actualizado el TIPO de la solicitud.');
              this.loading = false;
            },
            (err: HttpErrorResponse) => {
              // this.toastr.error('Ha ocurrido un problema al actualizar las opciones del servicio COPIA/ORIGINAL.' +
              //  ' Vuelva a intentarlo pasados unos segundos o póngase en contacto con soporte');
              this.toastr.error('No se ha podido actualizar la solicitud, compruebe que sea un prestamo y vuelvalo a intentar en unos minutos.');
              this.loading = false;
            }
          );
      } else {
        this.toastr.info('No se ha solicitado ningun cambio.');
      }

    });


  }

  preCargaModalParaCopiaOriginal() {
    this.solicitudeservice.comprobarTieneCopiaOriginal(this.viewDetails.ID_CLIENTE)
      .subscribe(
        (r: boolean) => {
          this.tieneOriginalCopia = true;
          // Modal
          this.showModalChangeOptions();
        },
        (e: Error) => {
          this.tieneOriginalCopia = false;
          this.toastr.error('El cliente no tiene servicio COPIA y ORIGINAL => ' + e.message);
        }
      );

  }

  // 🥑🥑 saber si tiene proveedores
  clienteTieneProveedores(idCliente: number) {

    this.proveedoresService.TieneProveedoresCliente(idCliente)
      .subscribe(result => {
        this.tieneProveedores = result;
      },
        (e: Error) => {
          this.tieneProveedores = false;
          this.toastr.error('Error a la hora de recuperar los proveedores del cliente => ' + e.message);
        }
      );
  }

  // 🥑🥑 saber si el usuario tiene algun grupo que tenga asociado el ID_PROVEEDOR de la solicitud
  usuarioTienePermisoCambioProveedor(idUsuario: number, idProveedor: number) {
    this.proveedoresService.TienePermisoCambioProveedor(idProveedor)
      .subscribe((result) => {
        this.tienePermisoCambiarProveedores = result;
      },
        (e: Error) => {
          this.tienePermisoCambiarProveedores = false;
          this.toastr.error('Error recuperando el permiso para cambiar de proveedor en la solicitud => ' + e.message);
        }
      );
  }

  // 🥑🥑 saber si el usuario tiene algun grupo que tenga asociado el ID_PROVEEDOR del contenido
  usuarioTienePermisoCambioProveedorCont(idUsuario: number, idProveedor: number) {
    this.proveedoresService.TienePermisoCambioProveedor(idProveedor)
      .subscribe((result) => {
        this.tienePermisoCambiarProveedoresCont = result;
      },
        (e: Error) => {
          this.tienePermisoCambiarProveedoresCont = false;
          this.toastr.error('Error recuperando el permiso para cambiar de proveedor en el contenido => ' + e.message);
        }
      );
  }
  // 🥑🥑 show modal cambio proveedor de la solicitud
  showModalChangeProveedor() {
    const modal = this.modalservice.show(ChangeProveedorSolicitudComponent, { backdrop: 'static', keyboard: false });
    (<ChangeProveedorSolicitudComponent>modal.content).showConfirmationModal(
      'Cambiar proveedor',
      'Seleccione el nuevo proveedor mediante el desplegable.',
      this.viewDetails.ID_CLIENTE,
      this.viewDetails.ID_PROVEEDOR,
      this.allSituaciones
    );
    (<ChangeProveedorSolicitudComponent>modal.content).onClose.subscribe(result => {
      return;
    });
    (<ChangeProveedorSolicitudComponent>modal.content).onSaveCambios.subscribe(datos => {

      if (datos.idProveedorFinal == undefined) {
        this.toastr.info('No se ha recuperado el proveedor seleccionado de forma correcta.');
      } else if (this.viewDetails.ID_PROVEEDOR != datos.idProveedorFinal) {

        this.proveedoresService.ActualizarIdProveedorSolicitud(this.id, datos.idProveedorFinal, datos.observacionesCambio, datos.situacionFinalTraza)
          .subscribe(
            (p) => {
              this.toastr.success('Se ha actualizado el proveedor de la solicitud.');
              if (!this.isDocoutUser) {
                this.router.navigate(['docout', { outlets: { contenido: ['panelmando'] } }]);
              }
              else {
                this.getDetailsSolicitud();
                this.thinking = false;
              }
            },
            (err: HttpErrorResponse) => {
              this.toastr.error('No se ha podido actualizar la solicitud.');
              this.thinking = false;
            }
          );
      } else {
        this.toastr.info('El proveedor seleccionado es el actual de la solicitud.');
      }
    });

  }

  // 🥑🥑 cargar modal de la solicitud
  preCargaModalParaCambioProveedor() {
    this.proveedoresService.TieneMasProveedoresCliente(this.viewDetails.ID_CLIENTE, this.viewDetails.ID_PROVEEDOR)
      .subscribe(
        (p) => {
          // Modal
          this.showModalChangeProveedor();
        },
        (e: Error) => {
          this.toastr.error('El cliente no tiene más proveedores asociados => ' + e.message);
        }
      );
  }

  // 🥑🥑 cargar modal del contenido
  preCargaModalParaCambioProveedorCont() {
    this.proveedoresService.TieneMasProveedoresCliente(this.viewDetails.ID_CLIENTE, this.viewDetails.ID_PROVEEDOR)
      .subscribe(
        (p) => {
          // Modal
          this.showModalChangeProveedorCont();
        },
        (e: Error) => {
          this.toastr.error('El cliente no tiene más proveedores asociados => ' + e.message);
        }
      );
  }

  // 🥑🥑 show modal cambio proveedor del contenido
  showModalChangeProveedorCont() {
    const modal = this.modalservice.show(ChangeProveedorSolicitudComponent, { backdrop: 'static', keyboard: false });
    (<ChangeProveedorSolicitudComponent>modal.content).showConfirmationModal(
      'Cambiar proveedor del contenido',
      'Seleccione el nuevo proveedor mediante el desplegable.',
      this.viewDetails.ID_CLIENTE,
      this.viewDetails.ID_PROVEEDOR,
      this.allSituaciones
    );
    (<ChangeProveedorSolicitudComponent>modal.content).onClose.subscribe(result => {
      return;
    });
    (<ChangeProveedorSolicitudComponent>modal.content).onSaveCambios.subscribe(datos => {

      if (datos.idProveedorFinal == undefined) {
        this.toastr.info('No se ha recuperado el proveedor seleccionado de forma correcta.');
      } else if (this.viewDetails.ID_PROVEEDOR != datos.idProveedorFinal) {

        this.proveedoresService.ActualizarIdProveedorContenido(parseInt(this.idcontenido, null), datos.idProveedorFinal, datos.observacionesCambio, datos.situacionFinalTraza)
          .subscribe(
            (p) => {
              this.toastr.success('Se ha actualizado el proveedor del contenido.');
              if (!this.isDocoutUser) {
                this.router.navigate(['docout', { outlets: { contenido: ['panelmando'] } }]);
              }
              else {
                this.getDetailsSolicitud();
                this.contenidoSeleccionadoMostrado = false;
                this.thinking = false;
              }
            },
            (err: HttpErrorResponse) => {
              this.toastr.error('No se ha podido actualizar el contenido.');
              this.thinking = false;
            }
          );
      } else {
        this.toastr.info('El proveedor seleccionado es el actual del contenido.');
      }
    });

  }

  // OAA
  obtenerInfoAdicionalGrupo() {
    this.grupoService.getInfoAdicionalGrupo(this.viewDetails.ID_SOLICITANTE).subscribe(
      infoAdicional => { this.infoAdicionalGrupo = infoAdicional },
      (e: Error) => {
        this.toastr.error('Error al recuperar la informacion adicional del grupo para el usuario creador => ' + e.message);
      });
  }

  private convertValuesToCSVRow(values: any[]): string {
    return values.join(';') + '\n';
  }

}
